var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWcart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.054,
    height: 84.495,
    viewBox: "0 0 95.054 84.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons-01",
    d: "M47.478,64.14a3.168,3.168,0,1,0,0,6.336H58.006c5.245,12.989,10.406,25.99,15.613,39.014l-4.786,11.521a3.165,3.165,0,0,0,2.938,4.4h52.8a3.168,3.168,0,0,0,0-6.336H76.523l2.74-6.537,50.862-4.057a3.265,3.265,0,0,0,2.828-2.445L139.3,78.553a3.315,3.315,0,0,0-3.1-3.862H66.526l-3.438-8.57a3.246,3.246,0,0,0-2.935-1.98Zm21.584,16.9h63.147l-4.915,21.323L79.131,106.19ZM82.331,127.51a10.563,10.563,0,1,0,10.563,10.563A10.563,10.563,0,0,0,82.331,127.51Zm31.688,0a10.563,10.563,0,1,0,10.56,10.562A10.563,10.563,0,0,0,114.019,127.51Zm-31.688,6.355a4.227,4.227,0,1,1-4.224,4.224,4.177,4.177,0,0,1,4.224-4.224Zm31.688,0a4.227,4.227,0,1,1-4.227,4.224,4.177,4.177,0,0,1,4.227-4.224Z",
    transform: "translate(-44.31 -64.14)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcart);
export default __webpack_public_path__ + "static/media/wcart.6bebf2fee759c5437a89fba1cea344bd.svg";
export { ForwardRef as ReactComponent };